export default [
    {
        name: 'Photo',
        value: 's_photo_link',
        image: true,
        customWidth: 70
    },
    {
        name: 'Status',
        value: 's_status',
        filter: 'ACTIVE'
    }, 

    {
        name: 'Employee #',
        value: 'i_employee_number' 
    },
    {
        name: 'First Name',
        value: 's_first_name' 
    },
    {
        name: 'Last Name',
        value: 's_last_name' 
    },
    {
        name: 'Email',
        value: 's_email' 
    }, 
    {
        name: 'Department',
        value: 's_department' 
    },
    {
        name: 'Job title',
        value: 's_job_title' 
    }
];